import { ChangeEvent, FC } from 'react';
import { Tabs, Tab } from '@mui/material';

interface DeloitteTabsProps {
    value: number;
    onChange: (event: ChangeEvent<{}>, newValue: number) => void;
}

export const DeloitteTabs: FC<DeloitteTabsProps> = (props: DeloitteTabsProps) => {
    return <Tabs textColor="secondary" {...props} TabIndicatorProps={{ children: <span /> }} sx={(theme) => {
        return {
            '& .MuiTabs-indicator': {
                padding: '0 16px',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                height: '4px',
                '& > span': {
                    width: '100%',
                    height: '4px',
                    backgroundColor: theme.palette.secondary.main,
                    borderRadius: theme.deloitte.radius
                }
            }
        }
    }} />;
}

interface DeloitteTabProps {
    label: string;
    fake?: boolean;
}

export const DeloitteTab: FC<DeloitteTabProps> = (props: DeloitteTabProps) => {
    const { fake, ...rest } = props;
    return <Tab {...rest} sx={(theme) => {
        return {
            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(15),
            marginRight: theme.spacing(1),
            '&.Mui-selected': {
                color: 'text.primary'
            },
            visibility: fake ? 'hidden' : undefined,
            minWidth: fake ? 0 : undefined,
            width: fake ? '1px' : undefined,
            minHeight: fake ? 0 : undefined,
            height: fake ? '1px' : undefined,
            padding: fake ? 0 : undefined,
        }
    }} />;
}